// extracted by mini-css-extract-plugin
export var cardSelected = "_hp-2";
export var image = "_hp-1";
export var table = "_hp-0";